import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class StarAnimation extends Animation {
  constructor(Star: PIXI.Sprite, dim: { width: number, height: number }) {
    super()
    new Tween.Tween(Star)
      .to({
        width: dim.width,
        height: dim.height
      }, 800)
      .easing(Tween.Easing.Quadratic.InOut)
      .repeat(Infinity)
      .yoyo(true)
      .start();
  }
}